import React from 'react';
import { Box, Typography, Button, Paper, Alert } from '@mui/material';
import { Warning, Refresh, Home } from '@mui/icons-material';

interface LazyLoadFallbackProps {
  error?: Error;
  pageName?: string;
}

const LazyLoadFallback: React.FC<LazyLoadFallbackProps> = ({ error, pageName = 'page' }) => {
  const handleRefresh = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        p: 3,
      }}
    >
      <Paper sx={{ p: 4, maxWidth: 500, textAlign: 'center' }}>
        <Warning color="warning" sx={{ fontSize: 48, mb: 2 }} />

        <Typography variant="h5" color="warning.main" gutterBottom>
          Failed to Load {pageName}
        </Typography>

        <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
          <Typography variant="body2">
            The {pageName} couldn't be loaded. This might happen after an app update.
            <br /><br />
            <strong>Try refreshing the page</strong> to load the latest version.
          </Typography>
        </Alert>

        {error && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              mb: 3,
              fontFamily: 'monospace',
              backgroundColor: 'grey.100',
              p: 2,
              borderRadius: 1,
              fontSize: '0.75rem',
              textAlign: 'left'
            }}
          >
            {error.message}
          </Typography>
        )}

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="contained"
            startIcon={<Refresh />}
            onClick={handleRefresh}
            color="warning"
          >
            Refresh Page
          </Button>
          <Button
            variant="outlined"
            startIcon={<Home />}
            onClick={handleGoHome}
          >
            Go Home
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default LazyLoadFallback;